import React from 'react';
import { EyeIcon, UserCircleIcon } from '@heroicons/react/24/solid';
import FooterLanding from './FooterLanding';
import ContentView from '../../elements/ContentView';
import { format } from 'date-fns';
import { BASE_URL } from '../../../services/api';
import { CalendarDateRangeIcon } from '@heroicons/react/20/solid';

export default function LayoutRead({ title, author, content, createdAt, photo, views, category }) {
    return (
        <div className="relative min-h-screen bg-surface-2">
            <div className="px-8 py-8">
                <div className="max-w-4xl mx-auto bg-white shadow-lg rounded-lg overflow-hidden">
                    <img src={`${BASE_URL}${photo}`} alt="Article Image" className="w-full h-full object-cover" />
                </div>
            </div>

            <div className="text-center py-8">
                <h1 className="text-5xl font-bold text-ink-900 line-clamp-2">{title}</h1>
                {/* Category Tag */}
                <div className="mt-2">
                    <span className="inline-block bg-line text-ink-700 text-sm px-3 py-1 rounded-full">
                        {category}
                    </span>
                </div>
                <div className="flex justify-center items-center mt-6 text-sm space-x-4">
                    <div className="flex items-center">
                        <UserCircleIcon className="w-5 h-5 mr-2" />
                        <p>{author}</p>
                    </div>
                    <div className="flex items-center">
                        <EyeIcon className="w-5 h-5 mr-2" />
                        <p>{views} pembaca</p>
                    </div>
                    <div className="flex items-center">
                        <CalendarDateRangeIcon className="w-5 h-5 mr-2" />
                        <p className="text-ink-500">{format(createdAt, 'dd MMMM yyyy')}</p>
                    </div>
                </div>
            </div>

            {/* Content Section */}
            <div className="px-8 md:px-32 py-12">
                <div className="max-w-4xl mx-auto bg-white shadow-lg rounded-lg p-8">
                    <div className="text-ink-700 space-y-4">
                        <ContentView content={content} />
                    </div>
                </div>
            </div>

            {/* Footer */}
            {/* <FooterLanding /> */}
        </div>
    );
}
